import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import SplitText from 'gsap/dist/SplitText'

export const getScrollTriggerOptions = (
  node: HTMLElement,
  reverse: boolean,
  start = 'top 82%' // 'top 92%'
) => {
  return {
    scrollTrigger: {
      trigger: node,
      once: !reverse,
      start,
      markers: false,
      toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
    }
  }
}


export const revealChars = (target: SplitText) => {

  gsap.set(target, { opacity: 0 })
  const splitChars = SplitText.create((target as any).element || target, {
    type: 'chars',
  })
  gsap.set(target, { opacity: 1 })

  return gsap
    .timeline()
    .fromTo(splitChars.chars, { y: '110%' }, { y: '0%', stagger: 0.06, duration: 1.5, ease: 'power3.out' })
}

export const revealLines = (target: SplitText) => {
  gsap.set(target, { opacity: 0 })

  const splitLines = SplitText.create((target as any).element || target, {
    type: 'lines',
    mask: 'lines'
  })

  gsap.set(target, { opacity: 1 })

  return gsap
    .timeline()
    .fromTo(
      splitLines.lines,
      { y: '150%' },
      { y: '0%', stagger: 0.1, duration: 1.5, ease: 'power3.out' }
    )
}

export const opacityRevealAnimation = (target: gsap.DOMTarget) => {
  return gsap
    .timeline()
    .fromTo(target, { opacity: 0 }, { opacity: 1, duration: 1.5, ease: 'power2.out' })
}


export const batchRevealAnimation = ({
  targets,
  reverse,
  stagger,
  delay
}: {
  targets: gsap.DOMTarget
  reverse: boolean
  stagger?: gsap.NumberValue | gsap.StaggerVars
  delay?: number
}) => {
  return ScrollTrigger.batch(targets, {
    // interval: 0.1, // time window (in seconds) for batching to occur.
    // batchMax: 3,   // maximum batch size (targets)
    once: !reverse,
    onEnter: (batch) =>
      gsap.fromTo(
        batch,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          stagger,
          delay
        }
      )
  })
}

export const batchOpacityRevealAnimation = ({
  targets,
  reverse,
  stagger,
  delay
}: {
  targets: gsap.DOMTarget
  reverse: boolean
  stagger?: gsap.NumberValue | gsap.StaggerVars
  delay?: number
}) => {
  gsap.set(targets, { opacity: 0 })

  return ScrollTrigger.batch(targets, {
    // interval: 0.1, // time window (in seconds) for batching to occur.
    // batchMax: 3,   // maximum batch size (targets)
    once: !reverse,
    start: 'top 82%',
    onEnter: (batch) =>
      gsap.to(batch, {
        opacity: 1,
        duration: 1.2,
        ease: 'power2.out',
        stagger,
        delay
      })
  })
}

export const batchScaleXRevealAnimation = ({
  targets,
  reverse,
  stagger,
  delay
}: {
  targets: gsap.DOMTarget
  reverse: boolean
  stagger?: gsap.NumberValue | gsap.StaggerVars
  delay?: number
}) => {
  gsap.set(targets, { scaleX: 0 })

  return ScrollTrigger.batch(targets, {
    // interval: 0.1, // time window (in seconds) for batching to occur.
    // batchMax: 3,   // maximum batch size (targets)
    once: !reverse,
    start: 'top 82%',
    onEnter: (batch) =>
      gsap.to(batch, {
        scaleX: 1,
        duration: 1,
        ease: 'power2.out',
        stagger,
        delay
      })
  })
}
